import SvgIcon from '@ixigo/icons/SvgIcon';
import cn from '@repo/shared/utils/cn';

export const NoServicable = (props: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<SvgIcon
			className={cn(props.className)}
			data-testid="NoServicableIcon"
			width="59"
			height="73"
			viewBox="0 0 59 73"
			fill="none"
			{...props}
		>
			<path
				d="M51.3837 67.7018C51.3837 70.0908 41.7083 72.0274 29.7731 72.0274C17.8378 72.0274 8.1624 70.0908 8.1624 67.7018C8.1624 65.3129 17.8378 63.3763 29.7731 63.3763C41.7083 63.3763 51.3837 65.3129 51.3837 67.7018Z"
				fill="#BEBFBF"
			/>
			<path
				d="M31.322 0.0273438C70.6677 5.82051 44.5116 49.7586 32.3499 67.7018H27.0253L9.48474 49.3372L9.55199 49.3336C4.00497 44.1797 0.500017 36.597 0.5 28.1422C0.5 12.6149 12.3212 0.0273438 26.9035 0.0273438C28.1415 0.0273438 27.838 0.0274 31.322 0.0273438Z"
				fill="#F2B4B3"
			/>
			<path
				d="M32.0965 0.0276816C46.6787 0.02775 58.5 12.615 58.5 28.1421C58.5 35.6636 55.726 42.4952 51.2081 47.5404L51.2267 47.5395L32.2183 67.7017L14.6778 49.3371L14.7455 49.3335C9.19827 44.1796 5.69308 36.5969 5.69305 28.1421C5.69305 12.6149 17.5143 0.0276816 32.0965 0.0276816Z"
				fill="#E35D5B"
			/>
			<path
				d="M40.4273 17.8224C41.4328 16.8162 43.0631 16.8161 44.0687 17.8224C45.0742 18.8288 45.0742 20.4606 44.0687 21.467L36.5054 29.0357L44.0687 36.6049C45.0742 37.6112 45.0742 39.243 44.0687 40.2494C43.0631 41.2556 41.4328 41.2556 40.4273 40.2494L32.864 32.6799L25.3011 40.249C24.2955 41.2554 22.6653 41.2554 21.6597 40.249C20.6541 39.2426 20.6541 37.6112 21.6597 36.6049L29.2226 29.0357L21.6597 21.467C20.6541 20.4606 20.6541 18.8288 21.6597 17.8224C22.6653 16.8162 24.2956 16.8161 25.3011 17.8224L32.864 25.3912L40.4273 17.8224Z"
				fill="#FFCFCE"
			/>
		</SvgIcon>
	);
};
